module.exports = __webpack_public_path__ + "static/media/itsolution-banner-img-1.68b5d645.jpg";